export enum AUTH_FOR {
  FRONT_END = 'FRONT_END',
  SERVER = 'SERVER',
}

// Oauth api response
export interface LogoutApiResponse {
  success: boolean;
  content: string;
}

export interface DashboardSessionStatusResponse {
  isAuthenticated: boolean;
  isSessionUsable: boolean;
  requiresReauthorization: boolean;
}

export interface ScopesOverviewResponse {
  availableScopes: string[];
  grantedScopes: string[];
  missingScopes: string[];
}
